var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "report-z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m327 222.14h546v755.71h-546z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#report-z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m327.67 283.66v694.2h544.67v-694.2h-143.54v65.988c0 8.8516-7.1758 16.027-16.016 16.027h-225.56c-8.8516 0-16.016-7.1758-16.016-16.027v-65.988zm175.57 49.973h193.52v-49.973h-35.234c-8.8516 0-16.027-7.1758-16.027-16.027 0-12.559-5.0898-23.938-13.32-32.168v-0.0625c-8.1875-8.1875-19.559-13.262-32.168-13.262-12.566 0-23.938 5.0898-32.168 13.32-8.2305 8.2305-13.332 19.609-13.332 32.168 0 8.8516-7.168 16.027-16.016 16.027h-35.246v49.973zm-5.1133 186.88 83.359 70.223 118.45-139.9c5.6992-6.7344 15.789-7.5703 22.523-1.8789 6.7422 5.6992 7.5781 15.801 1.8789 22.535l-128.76 152c-5.668 6.7109-15.707 7.5586-22.43 1.9102l-95.547-80.488c-6.7422-5.668-7.6094-15.727-1.9414-22.461 5.6602-6.7422 15.719-7.6094 22.461-1.9414zm-63.668 220.68h331.07c8.8516 0 16.027 7.168 16.027 16.016 0 8.8516-7.1758 16.027-16.027 16.027h-331.07c-8.8516 0-16.016-7.1758-16.016-16.027 0-8.8516 7.168-16.016 16.016-16.016zm0 113.84h331.07c8.8516 0 16.027 7.168 16.027 16.016 0 8.8516-7.1758 16.016-16.027 16.016h-331.07c-8.8516 0-16.016-7.168-16.016-16.016 0-8.8516 7.168-16.016 16.016-16.016z",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.1c2732c066eaaa5952384d9aef07c18d.svg";
export { ForwardRef as ReactComponent };